import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-bottom">
        <span>© 2026 SupportCare, Inc. All rights reserved.</span>
        <div style={{ display: 'flex', gap: 22 }}>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          {/* <a href="#">help@supportcare.io</a> */}
        </div>
      </div>
      <p className="footer-disclaimer" style={{ marginTop: 0, paddingBottom:80 }}>
        SupportCare is not a government agency. We are an independent service that helps
        families navigate eligibility and applications for state and federal caregiving
        programs. Eligibility and payment amounts are determined by the relevant agency.
      </p>
    </div>
  </footer>
);

export default Footer;
